import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, CheckIcon, LeafIcon } from 'lucide-react';
export const CertifiedQuality = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-895">
      <div className="bg-white p-4 flex justify-between items-center cursor-pointer" onClick={() => setIsExpanded(!isExpanded)} data-id="element-896">
        <h3 className="text-lg font-bold text-gray-800" data-id="element-897">
          Certified Quality & Packaging
        </h3>
        {isExpanded ? <ChevronUpIcon className="h-5 w-5 text-gray-600" data-id="element-898" /> : <ChevronDownIcon className="h-5 w-5 text-gray-600" data-id="element-899" />}
      </div>
      {isExpanded && <div className="bg-white p-6 border-t border-gray-200" data-id="element-900">
          <div className="space-y-6" data-id="element-901">
            <div data-id="element-902">
              <h4 className="text-lg font-medium text-gray-800 mb-2" data-id="element-903">
                Certified Refurbished & Affordable Smartphones
              </h4>
              <p className="text-gray-600" data-id="element-904">
                At SellUp, you will always find high-quality, certified
                refurbished electronics tested by our expert refurbishing
                partners. These pre-owned products are professionally cleaned
                and inspected. SellUp guarantees buyer satisfaction, battery
                health, and reduced negative impact on the environment.
              </p>
            </div>
            <div data-id="element-905">
              <h4 className="text-lg font-medium text-gray-800 mb-2" data-id="element-906">
                What's included in the box?
              </h4>
              <ul className="list-disc pl-5 text-gray-600 space-y-1" data-id="element-907">
                <li data-id="element-908">Professionally refurbished smartphone</li>
                <li data-id="element-909">Certified charging cable</li>
              </ul>
            </div>
            <div data-id="element-910">
              <h4 className="text-lg font-medium text-gray-800 mb-2" data-id="element-911">
                What to look for in a pre-owned smartphone?
              </h4>
              <p className="text-gray-600 mb-2" data-id="element-912">
                Originality & Quality. All pre-owned smartphones at SellUp are
                guaranteed original. They're 100% functional and undergo
                rigorous 70+ quality checks before shipping.
              </p>
              <div className="flex flex-wrap gap-4 mt-4" data-id="element-913">
                <div className="flex items-center bg-green-50 rounded-full px-4 py-2" data-id="element-914">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-915" />
                  <span className="font-medium" data-id="element-916">70+ quality checks</span>
                </div>
                <div className="flex items-center bg-green-50 rounded-full px-4 py-2" data-id="element-917">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-918" />
                  <span className="font-medium" data-id="element-919">100% functional</span>
                </div>
                <div className="flex items-center bg-green-50 rounded-full px-4 py-2" data-id="element-920">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-921" />
                  <span className="font-medium" data-id="element-922">Authentic devices</span>
                </div>
              </div>
            </div>
            <div data-id="element-923">
              <h4 className="text-lg font-medium text-gray-800 mb-2" data-id="element-924">
                What are the carbon footprint savings of a used smartphone?
              </h4>
              <p className="text-gray-600 mb-4" data-id="element-925">
                You save 70% of the carbon footprint of a new device by buying
                used and certified preowned.
              </p>
              <div className="bg-green-50 rounded-lg p-4 flex items-center" data-id="element-926">
                <LeafIcon className="h-10 w-10 text-green-600 mr-4" data-id="element-927" />
                <div data-id="element-928">
                  <div className="text-lg font-medium text-gray-800" data-id="element-929">
                    70% Carbon Footprint Reduction
                  </div>
                  <div className="text-gray-600" data-id="element-930">
                    Make an eco-friendly choice with every purchase
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};